<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*商品コード"
          v-model="item.cd"
          :error-messages="validation_errors.cd"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*商品カテゴリ"
          :items=$store.getters.productCategories
          item-text="name"
          item-value="id"
          v-model="item.productcategory_id"
          :error-messages="validation_errors.productcategory_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*商品名"
          v-model="item.name"
          :error-messages="validation_errors.name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="備考"
          v-model="item.note"
          :error-messages="validation_errors.note"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
        v-if="!$attrs.isCreate"
      >
      <v-btn
        v-if="item.id"
        class="default"
        :to="{ name: 'ProductDetail', params: {id: item.id}}"
      >商品明細</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      item: {},
      validation_errors: {},
    };
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "商品新規登録";
    } else {
      this.title = "商品編集";
      this.getItem();
    }
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'ProductList'}).catch(()=>{});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push({'name': 'EditProduct', 'params': {id: this.item.id}});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
  }
}
</script>